<div class="clock_properties">
  <small class="debug">{{me}}</small>
  @if (dynamicsInitialized) {
    <div>
      <dynamic-form #dynamicFormComponent [fields]="uiConfigInit" (submit)="submit($event)" [ignoreValidation]="true">
      </dynamic-form>
      <hr/>
      <app-font-selector (onChange)="onFontChanged($event, '', 'LabelQueue')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
      <hr/>
      <br/>
    </div>
  }
</div>
